import { ApiTaskKanbanStatus } from "src/api/types";
import Select from "src/components/field/fields/Select";
import { WrapperProps } from "src/components/field/utils/Wrapper";
import TaskStatus from "src/components/tasks/TaskStatus";
import useTaskStatuses from "src/hooks/api/tasks/useTaskStatuses";

interface StatusProps {
	wrapper: WrapperProps;
	value: ApiTaskKanbanStatus;
	onChange: (value?: string) => void;
}

const Status = ({ wrapper, value, onChange }: StatusProps) => {
	const { statuses } = useTaskStatuses();
	return (
		<Select
			{...{ wrapper }}
			onChange={(value) => {
				onChange(value);
			}}
			value={value as any}
			options={statuses.map((status) => ({
				value: status,
				label: <TaskStatus size="regular" {...{ status }} />,
			}))}
			theme={{
				item: {
					className: "radix-highlighted:bg-gray",
				},
			}}
		/>
	);
};

export default Status;
